import { CtaButton, LinkButton } from "@components/button"
import { FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@const/pictures"
import clsx from "clsx"
import { AppImage as Image } from "@components/misc"

export function CtaWebapp() {
  return (
    <section
      className={clsx(
        "bg-white relative w-full sm:py-[86.5px] py-[72px]",
        "flex items-center justify-center"
      )}
    >
      {/* <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/home_cta-assets-1.png`}
        alt="cta-top-left"
        width={300}
        height={300}
        className="absolute top-0 left-0 w-[100px] sm-only:hidden"
      />
      <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/home_cta-assets-2.png`}
        alt="cta-top-right"
        width={300}
        height={300}
        className="absolute top-0 right-0 w-[100px] sm-only:hidden"
      /> */}

      <FlexBox
        className="m-auto sm:gap-8"
        justify="center"
        align="center"
        direction="col"
      >
        <div className="grid gap-3 sm-only:mb-6">
          <h3
            className={clsx(
              "font-urbanist sm:text-[40px] font-semibold text-center",
              "text-2xl sm-only:mb-3"
            )}
          >
            Galau? Bingung?
          </h3>
          <div className="sm:text-2xl text-center sm-only:px-[18px]">
            Obrolin dulu aja dengan team admission harisenin.com!
          </div>
        </div>
        <CtaButton />
      </FlexBox>

      {/* <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/home_cta-assets-3.png`}
        alt="cta-bottom-right"
        width={300}
        height={300}
        className="absolute bottom-0 right-0 w-[50px] h-auto sm-only:hidden"
      />
      <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/home_cta-assets-4.png`}
        alt="cta-bottom-left"
        width={300}
        height={300}
        className="absolute bottom-0 left-0 w-[100px] sm-only:hidden"
      /> */}
    </section>
  )
}
